<template>
    <div class="collapsible-body">
        <div class="row baseheader" style="width: 100%;"  v-if="new_material == undefined">
            <div class="col s1">
            </div>
            <div class="col s3 input-field">
                <span v-on:click="setMaterialsOrder('name')">{{$t('materials.name')}}</span>
                <i class="material-icons dp6" v-if="ordermaterialby == 'name' && ordermaterial == 'desc'">arrow_drop_down</i>
                <i class="material-icons dp6" v-if="ordermaterialby == 'name' && ordermaterial == 'asc'">arrow_drop_up</i>
                <input name="materialsearch" v-model="materialsearch" />
            </div>
            <div class="col s8" style="text-align: end;" v-if="role == 'ddd_admin' || (role == 'ddd_worker' && extended_privileges)">
                <a class="waves-effect waves-light btn solidgreen" v-on:click="addMaterial()" style="margin-top: 20px;">{{$t('materials.add')}}</a>
            </div>
        </div>
        <ul class="collapsible">
            <li v-if="new_material != undefined">
                <material
                    v-bind:material="new_material"
                    v-on:addMaterial="addedMaterial"
                    v-on:removeMaterial="removeMaterial"
                    v-on:cancelMaterial="materialCancelled"
                    :extended_privileges="extended_privileges"
                    ref="newMaterial"/>
            </li>
            <li v-for="material in listMaterials">
                <div class="collapsible-header reded">
                    <div class="row" style="width: 100%;">
                        <div class="col s1">
                            <template v-if="material.image != null && material.image != undefined">
                                <v-lazy-image
                                    v-bind:src="material.image"
                                    src-placeholder="/nofoto.png"
                                    width="64"
                                    v-on:error="imageLoadError(material)"
                                />
                            </template> 
                            <template v-else>
                                <img src="/nofoto.png" style="width: 64px;"/>
                            </template>
                        </div>
                        <div class="col s3"> {{material.name}}</div>
                    </div>
                </div>
                <material
                    v-bind:material="material"
                    v-on:removeMaterial="removeMaterial" 
                    v-on:cancelMaterial="materialCancelled"
                    :extended_privileges="extended_privileges"
                    ref="materials"/>
            </li>
            <li>
                <div class="row" style="width: 100%;" v-if="materials_loaded == false">
                    <div class="col s12">
                        <div class="container" style="width: 3%; margin: auto;">
                            <div class="preloader-wrapper active">
                                <div class="spinner-layer spinner-red-only">
                                    <div class="circle-clipper left">
                                        <div class="circle"></div>
                                    </div>
                                    <div class="gap-patch">
                                        <div class="circle"></div>
                                    </div>
                                    <div class="circle-clipper right">
                                        <div class="circle"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style="width: 100%;" v-if="materials_loaded && listMaterials.length == 0">
                    {{$t('materials.no_materials')}}
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import _ from 'lodash';

export default {
    props: { role: String, extended_privileges: Boolean },
    data: function() {
        return {
            ordermaterialby: 'name',
            ordermaterial: 'desc',
            materialsearch: "",
            materials_loaded: false,
            materials: [],
            new_material: undefined
        }
    },
    created() {
        this.fetch_pests();
    },
    mounted() {
        var elems = document.querySelectorAll('.collapsible');
        var instances = M.Collapsible.init(elems, { accordion: true });
    },
    methods: {
        fetch_pests: function() {
            var that = this;
            axios.get('/material_items.json').then(response => {
                this.materials = response.data;
                for (var i = this.materials.length - 1; i >= 0; i--) {
                    this.materials[i].edit = false;
                }
                this.materials_loaded = true;
            });
        },
        anyEdited: function(){
            if(_.isUndefined(this.$refs.materials) == false){
                for (var i = this.$refs.materials.length - 1; i >= 0; i--) {
                    if(this.$refs.materials[i].material.edit){
                        return true;
                    }
                }
            }
            if(_.isUndefined(this.$refs.newMaterial) == false){
                if(this.$refs.newMaterial.material.edit){
                    return true;
                }
            }
            return false;
        },
        addMaterial() {
            this.new_material = { edit: true, editable: true, name: "", description: "", default_unit: "pieces", media: [] }
            this.$forceUpdate();
        },
        removeMaterial(material) {
            if (material.id != undefined) {
                if (confirm("Czy chcesz usunąć " + material.name + " ?")) {
                    var that = this;
                    axios.delete("/material_items/" + material.id + ".json").then((response) => {
                        that.materials.splice(that.materials.indexOf(material), 1);
                    })
                }
            } else {
                this.new_material = undefined;
            }
        },
        materialCancelled(material){
            
        },
        addedMaterial(material) {
            this.materials.push(material)
            this.$forceUpdate();
        },
        setMaterialsOrder: function(order) {
            if (this.ordermaterialby == order) {
                if (this.ordermaterial == 'desc') {
                    this.ordermaterial = 'asc'
                } else if (this.ordermaterial == 'asc') {
                    this.ordermaterial = 'desc'
                }

            } else {
                this.ordermaterialby = order;
            }
        },
        imageLoadError: function(material){
            material.image = null;
        }
    },
    computed: {
        listMaterials() {
            var that = this;
            return _.filter(
                _.orderBy(this.materials, this.ordermaterialby, this.ordermaterial),
                function(item) {
                    return (item.name.toUpperCase().indexOf(that.materialsearch.toUpperCase()) >= 0)
                }
            );
        }
    },
    mixins: [Vue2Filters.mixin],
}
</script>
<style scoped>
.settingsform {
    padding-top: 15px;
}

.login_button {
    color: red;
}

p {
    font-size: 2em;
    text-align: center;
}

.selectorignored select {
    display: block;
}

.formul .row .col {
    padding-bottom: 15px;
}

.formul .s12 .input-field {
    width: 90%
}

.formul .s4 .input-field {
    width: 60%
}

.formul .s6 .input-field {
    width: 60%
}

.input-field {
    margin: 0px !important;
}

.settingsform>.row {
    margin-bottom: 0px;
}

.settingsform>.row>.collapsible {
    margin-bottom: 0px;
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.collapsible-header {
    background-color: #8A8D91;
    text-transform: uppercase;
}

.collapsible-body .collapsible-header {
    background-color: #FFF;
    text-transform: initial;
}

.collapsible-body .collapsible-header .row {
    margin-bottom: 0px;
}

.collapsible-body .collapsible-body.formul {
    background-color: #FFF;
    margin-top: 5px;
    border-bottom-style: solid;
    border-bottom-width: 5px;
}

.baseheader {
    background-color: #DADADA;
    margin-bottom: 0px;
}

.collapsible {

    margin-left: 15px;
    margin-right: 15px;
    box-shadow: 0 0px 0px;
    border: 0px;
}

.collapsible li {
    padding-bottom: 15px;
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.solidgreen {
    background-color: #00CC66 !important;
    color: black;
}

.active>.reded {
    border-color: rgb(194, 32, 38);
    border: 4px solid rgb(194, 32, 38);
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.inline>select {
    display: block !important;
}

.collapsible-body {
    padding: 1em;
    padding-right: 0em;
    padding-left: 1em;
}

.collapsible li i {
    position: absolute;
    right: 15px;
}

.collapsible li.active i {
    -ms-transform: rotate(180deg);
    /* IE 9 */
    -webkit-transform: rotate(180deg);
    /* Chrome, Safari, Opera */
    transform: rotate(180deg);
}

.input-field {
    margin-top: 0rem;
    margin-bottom: 0rem;
}

.btn-small {
    color: black;
    border-radius: 8px;
}
</style>